"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClientRequestError = void 0;
const http_client_utils_1 = require("./http-client-utils");
class HttpClientRequestError extends Error {
    constructor(error) {
        super();
        // @ts-expect-error necessary to identify this object
        this.__isHttpClientRequestError = true;
        this.name = 'HttpClientRequestError';
        this.type = (0, http_client_utils_1.getRequestErrorType)(error);
        this.response = error === null || error === void 0 ? void 0 : error.response;
    }
}
exports.HttpClientRequestError = HttpClientRequestError;
//# sourceMappingURL=http-client-error.js.map